import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

export const customerSelector = ({ entities }: RootState) => {
  return entities.customer;
};

export const getCustomerState = createSelector(
  customerSelector,
  ({
    isLoading, error, customers, selectedCustomer,
  }) => {
    return {
      isLoading, error, customers, selectedCustomer,
    };
  },
);